// ⚠️ FICHIER GÉNÉRÉ — ne pas éditer ici. Source : shared/ui/ · régénérer avec `bash shared/sync.sh`
/**
 * Apparence d'un SEGMENT (onglets, filtres à choix unique) — la seule définition.
 *
 * Module PUR, comme `boutonStyles.ts` : testé par `npm test`. Jetons `var(--…)` uniquement, et
 * seulement des jetons présents dans `ged`, `manuel` et `site`.
 *
 * Un segment N'EST PAS une action : il montre un état (« je regarde la vue X ») et ne compte donc
 * pas parmi « l'action principale » de l'écran (shared/docs/UI-CONVENTIONS.md §1). C'est pourquoi la
 * sélection n'est PAS un bouton plein cyan : un onglet actif à côté de « Enregistrer » ferait deux
 * boutons principaux. L'option choisie se lit en carte blanche posée sur le rail, texte foncé.
 */
import type { CSSProperties } from 'react';
import { HAUTEUR_BOUTON, type TailleBouton } from './boutonStyles';

/** Le rail a la hauteur d'un bouton de même taille ; les options occupent ce qu'il reste. */
const PADDING_RAIL = 3;
const BORDURE_RAIL = 1;
export const HAUTEUR_OPTION_SEGMENT: Record<TailleBouton, number> = {
  md: HAUTEUR_BOUTON.md - 2 * (PADDING_RAIL + BORDURE_RAIL),
  sm: HAUTEUR_BOUTON.sm - 2 * (PADDING_RAIL + BORDURE_RAIL),
};

export function styleSegmentRail(pleineLargeur = false): CSSProperties {
  return {
    display: pleineLargeur ? 'flex' : 'inline-flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 2,
    boxSizing: 'border-box',
    width: pleineLargeur ? '100%' : 'fit-content',
    padding: PADDING_RAIL,
    background: 'var(--surface-sunken)',
    border: `${BORDURE_RAIL}px solid var(--border-default)`,
    borderRadius: 'var(--radius-md)',
  };
}

export function styleSegmentOption(actif: boolean, taille: TailleBouton = 'sm', pleineLargeur = false): CSSProperties {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    boxSizing: 'border-box',
    flex: pleineLargeur ? '1 1 0' : 'none',
    minHeight: HAUTEUR_OPTION_SEGMENT[taille],
    padding: taille === 'md' ? '0 16px' : '0 12px',
    fontFamily: 'var(--font-sans)',
    fontSize: taille === 'md' ? 13.5 : 12.5,
    fontWeight: actif ? 700 : 600,
    border: 'none',
    borderRadius: 'var(--radius-sm)',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    background: actif ? 'var(--surface-card)' : 'transparent',
    color: actif ? 'var(--navy-900)' : 'var(--text-muted)',
    boxShadow: actif ? 'var(--shadow-sm)' : 'none',
  };
}
